<template>
    <div>

        <el-row style="margin-bottom:10px;">
            <el-col :span="18" class='flex'>
                <el-select v-if="theUserProject == 0" v-model="theProjectId" @change="theProjectAllChange" size="small"
                    clearable placeholder="请选择项目">
                    <el-option v-for="item in getProjectList_data.data || []" :key="item.projectId"
                        :label="item.projectName" :value="item.projectId">
                    </el-option>
                </el-select>
                <el-input v-model="getYcAiAppList_data.aaTitle" placeholder="请输入标题" clearable size='small'
                    style="max-width:200px;" />
                <!-- <el-select v-model='getYcAiAppList_data.mtmId' clearable placeholder="请输入分类" size='small'
                    style="max-width:200px;">
                    <el-option v-for="item in getMicrolectureTypeMainList_data || []" :key="item.mtmId"
                        :label="item.mtmName" :value="item.mtmId"></el-option>
                </el-select> -->
                <el-button @click="getData" type="primary" icon='el-icon-search' size='small'
                    style='margin-left:10px;'>搜索
                </el-button>
            </el-col>
            <el-col :span="6">
                <el-button v-if="addYcAiApp" @click=" $form('addYcAiApp')" size='small' type="primary"
                    style="float:right" icon='el-icon-circle-plus'>添加智能体
                </el-button>
            </el-col>
        </el-row>

        <mytable :tableColums='tableColums_getYcAiAppList' api='getYcAiAppList' xupdateapi='updateYcAiApp'
            :height="H - 165">
            <icol slot='aaIcon' :showtooltip='false' img='aaIcon' />
        </mytable>
        <myform :viewobj='{
            updateYcAiAppCopyToOtherProject: ["复制智能体工具到其他项目", "el-icon-edit-outline"],
            $succeed$: getYcAiAppList
        }' @closed="$form('updateYcAiAppCopyToOtherProject', 'reset'), window.sleep(50, v => Myformdata)
            ">
            <template v-slot:projectId="{ Myformdata }">
                <el-select v-model="Myformdata.projectId" clearable placeholder="请选择项目">
                    <el-option v-for="item in getProjectList_data.data || []" :key="item.projectId"
                        :label="item.projectName" :value="item.projectId">
                    </el-option>
                </el-select>
            </template>
            <hide slot='yaaId' />
        </myform>
        <myform :viewobj='{
            addYcAiApp: ["新增智能体", "el-icon-circle-plus"],
            updateYcAiApp: ["修改智能体", "el-icon-edit-outline"],
            $succeed$: getYcAiAppList
        }' @closed="$form('updateYcAiApp', 'reset'), window.sleep(50, v => Myformdata && (Myformdata.aaIcon = ''))
            " @confirm='myform'>
            <template v-slot:aaIcon='{ Myformdata }'>
                <myupload v-event.fileUpload='`
                      return (Myformdata.aaIcon+"").startsWith("http") 
                        || ( (C = (await C.MyUpload()).file) ? Myformdata.aaIcon = C : false )
                    `' @change='Myformdata.aaIcon = ($file$ = arguments[0]).url'
                    @remove='window.sleep(150, v => Myformdata.aaIcon = "")' type='image' :limit='1'
                    :params='{ file: "$file$" }' :filelist="Myformdata.aaIcon && Myformdata.aaIcon != ' '
                        ? ({ name: Myformdata.aaIcon, url: Myformdata.aaIcon })
                        : false"
                    :style="{ height: Myformdata.aaIcon && $form('updateMicrolecture', 'ifshow') ? '250px' : '' }">
                </myupload>
            </template>
            <hide slot='yaaId' />
        </myform>
    </div>
</template>

<script>
export default {
    data() {
        return {
            mainType: [],
            yaaId: null,
            theyaaId: "",
            getMicrolectureTypeMainList_data: [],
            tableColums_getYcAiAppList: {
                $selection: false,

                aaTitle: '智能体标题',
                aaAppId: '智能体id',
                aaIcon: '图标',
                aaModelDes: '描述',
                createtime: '创建时间',

                $operation: [
                    '操作', 200,
                    this.updateYcAiAppCopyToOtherProject && `@text: 复制到其他项目#primary
                    @click: $form("updateYcAiAppCopyToOtherProject",$row)
            `,
                    this.updateYcAiApp && `@text: 编辑#warn
             @click: $form("updateYcAiApp",$row)
            `,
                    this.deleteYcAiApp && `@text: 删除#danger
             @click: _confirm('确定要删除该微课吗?')
                     .trigger('deleteYcAiApp',{yaaId:$row.yaaId})
                     .trigger('getYcAiAppList')
            `,
                ],

            },

        };
    },

    watch: {

    },

    methods: {
        async myform(submit, Myformdata) {
            const res = await this.$trigger("fileUpload").trigger(res => res && this.sub(submit))
        },
        async sub(submit) {
            this.$nextTick(() => {

            })
            submit();
        },
        theProjectAllChange(e) {
            this.theProjectId = e;
            this.getData()
        },
        getData() {
            this.getYcAiAppList({
                ...this.getYcAiAppList_data,
                projectId: this.theProjectId
            })
        }
    },

    async created() {
        //   this.getMicrolectureTypeMainLists().result((res) => {
        //     if (res.data.data) {
        //       console.log(res.data.data);
        //       this.getMicrolectureTypeMainList_data = res.data.data
        //     }
        //   }) 
        this.theUserProject = A.local("$projectId");
        if (this.theUserProject == 0) {
            this.getProjectList({
                pageSize: 0
            });
        } else {
            this.theProjectId = this.theUserProject;
        }
        this.getYcAiAppList();
    }
};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/views/AiAgent/AiAgentList.vue